import { createScopedAction } from '@mews/framework';
import { getCurrentEnterpriseId } from '@mews-commander/core';

export const createCurrentEnterpriseScopedAction = createScopedAction(getCurrentEnterpriseId);
